export default {
  methods: {
    // Calculate total hits in a list of dice groups.
    calcTotalHits (dice) {
      return dice.reduce((hits, group) => hits + this.calcGroupHits(group), 0)
    },

    // Calculate total misses in a list of dice groups.
    calcTotalMisses (dice) {
      return dice.reduce((misses, group) => misses + this.calcGroupMisses(group), 0)
    },

    // Calculate hits from an array of die values.
    calcGroupHits (group) {
      return group.reduce((hits, value) => value >= 5 ? hits + 1 : hits, 0)
    },

    // Calculate misses from an array of die values.
    calcGroupMisses (group) {
      return group.reduce((misses, value) => value === 1 ? misses + 1 : misses, 0)
    },

    // Calculate dice pool from an array of die values.
    calcDicePool (dice) {
      return dice.reduce((count, group) => count + group.length, 0)
    },

    // Calculate sum from an array of die values.
    calcSum (dice) {
      return dice.reduce(
        (sum, group) => group.reduce(
          (groupSum, value) => groupSum + value,
          0),
        0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/diceTools.js